module.exports = __webpack_public_path__ + "img/thankyou.c3ccd6bc.svg";